import { Lesson } from "@jelly/lesson";
import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "c82418a0-8712-4dcf-be15-346b021c6d24",
  publicId: "16",
  name: "Airborne and impact sound, direct and flanking transmission",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, task01],
};

export default lesson;
